/* eslint-disable import/no-mutable-exports */
import SignatureContainer from "./SignatureContainer";

export default SignatureContainer;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/SignatureContainer/index.js